import Porthole from '../../../static/js/vendors/porthole/porthole.min';

/**
 * Callback for messages sent from iframe
 * @callback IframeMessengerMixinMessageCallback
 * @param {object} event - message sent from iframe
 */

/**
 * Iframe message
 * @typedef {Object} IframeMessengerMixinIframeMessage
 * @property {string} action - Action to perform
 * @property {string} id - Unique id of the message
 */

/**
 * This mixin allows simple way to communicate with iframes
 *
 * @param {string} parentDomain - Domain of the parent frame
 * For android device running cordova,
 * the domain is file, i.e. 'file:///android_asset/www/proxy.html'
 * @mixin
 */
const IframeMessengerMixin = function (parentDomain) {
    /**
     * messenger instance
     * @member {d.WindowProxy} messenger
     * @memberOf IframeMessengerMixin
     */
    this.messenger = new Porthole.WindowProxy(parentDomain);

    /**
     * Adds a callback for messages sent from iframe
     * @method addIframeEventListener
     * @param {IframeMessengerMixinMessageCallback} listener -
     * function to process incoming messages
     * @memberOf IframeMessengerMixin
     */
    this.addIframeEventListener = function (listener) {
        this.messenger.addEventListener(listener);
    }.bind(this);

    /**
     * Send message to target iframe
     * @method postMessageToParentIframe
     * @param {IframeMessengerMixinIframeMessage} message
     * @memberOf IframeMessengerMixin
     */
    this.postMessageToParentIframe = function (message) {
        this.messenger.post(message);
    };

    return this;
};

export { IframeMessengerMixin };
